var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticStyle: { "min-height": "64px" },
      attrs: { color: "grey lighten-3", dark: _vm.isDark },
    },
    [
      _c(
        "v-layout",
        { attrs: { row: "", "justify-end": "", "pa-2": "", wrap: "" } },
        [
          _vm.title || _vm.icon
            ? _c(
                "v-flex",
                { attrs: { "justify-self-start": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _vm.icon
                        ? _c(
                            "v-flex",
                            { attrs: { shrink: "", "pt-1": "", "pl-2": "" } },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "info", "x-large": "" } },
                                [_vm._v(_vm._s(_vm.icon))]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.title
                        ? _c(
                            "v-flex",
                            {
                              attrs: {
                                shrink: "",
                                headline: "",
                                "pl-2": "",
                                "pt-2": "",
                                "info--text": "",
                                "font-weight-medium": "",
                              },
                            },
                            [
                              _vm._l(_vm.breadCrumbs, function (crumb, index) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      key: index,
                                      staticStyle: { cursor: "pointer" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "onClickBreadcrumb",
                                            crumb
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { cursor: "pointer" } },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(crumb.text) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "info" } },
                                        [_vm._v("chevron_right")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.title) +
                                  "\n        "
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.actions, function (action, index) {
            return [
              !action.isVisibleFunc ||
              (action.isVisibleFunc && action.isVisibleFunc())
                ? _c(
                    "v-flex",
                    { key: index, attrs: { shrink: "" } },
                    [
                      _c("ControlButton", {
                        attrs: {
                          text: action.text,
                          icon: action.icon,
                          buttonColor: action.buttonColor,
                          iconColor: action.iconColor,
                          depressed: action.depressed,
                          disabled:
                            (action.isDisabledFunc &&
                              action.isDisabledFunc()) ||
                            _vm.isLoading,
                          isLoading: _vm.isLoading && action.showIsLoading,
                        },
                        on: {
                          onClicked: function ($event) {
                            return _vm.$emit("onClicked", action.emitEvent)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _vm.shouldShowSearch
            ? _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md5: "", lg4: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "rounded",
                    attrs: {
                      clearable: "",
                      solo: "",
                      label: "Search",
                      "prepend-inner-icon": "search",
                      "hide-details": "",
                    },
                    on: {
                      input: _vm.onShouldSearch,
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.onShouldSearch.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.searchText,
                      callback: function ($$v) {
                        _vm.searchText = $$v
                      },
                      expression: "searchText",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.toolbarExtension
            ? _c(
                "v-flex",
                { attrs: { xs12: "", "pr-2": "", "pl-2": "", "pt-1": "" } },
                [_vm._t("toolbarExtension")],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }